module.exports = __webpack_public_path__ + "img/doctor.ce943912.svg";